export default __webpack_public_path__ + "static/media/thankYou.71901b37.svg";